<template>
  <div>
    <div :id="'waveform-' + playerId" />
  </div>
</template>

<script>
import WaveSurfer from "wavesurfer.js";

export default {
  props: {
    playerId: {
      type: String,
      required: true,
    },
    filePath: {
      type: String,
      required: true,
    },
    waveform: {
      type: String,
      required: false,
      default: null,
    },
  },
  data: () => ({
    player: null,
  }),
  mounted() {
    this.buildPlayer();
  },
  methods: {
    async buildPlayer() {
      const self = this;
      if (this.player) {
        this.player.destroy();
        this.player = null;
      }

      const player_config = {
        container: '#waveform-' + self.playerId,
        waveColor: '#ba5248',
        progressColor: '#bd2718',
        containerWidth: '100%',
        normalize: true,
        barWidth: 3,
        backend: 'MediaElement',
      };

      let waveform_data = null;

      if (this.waveform) {
        const waveform_response = await this.getJsonFromFile(this.waveform);
        if (waveform_response) {
          waveform_data = waveform_response;
        }
      } else {
        toastr.info("A waveform has not yet been created for this file. It may take longer to load.");
      }

      this.player = WaveSurfer.create(player_config);

      if (waveform_data) {
        this.player.song = this.filePath;
        this.player.backend.peaks = waveform_data;
        this.player.drawBuffer();
        this.player.loaded = false;
      } else {
        this.player.load(this.filePath);
      }

      // Resize waveform on window resize
      const responsive_wave = this.player.util.debounce(() => {
        self.player.drawBuffer();
      }, 150);
      window.addEventListener('resize', responsive_wave);
    },
    async getJsonFromFile(path) {
      const url = `${window.public_media_path}waveforms/${path}`;
      const response = await $.getJSON(url, data => data);

      if (response.data) {
        return response.data;
      }
    },
  },
};
</script>
